/* eslint-disable */
import * as Types from '../../../shared/__gql-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetGpsUnitsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetGpsUnitsQuery = { __typename: 'Query', getGpsUnits: Array<{ __typename: 'Unit', name: string, alias: string }> | null };


export const GetGpsUnitsDocument = gql`
    query getGpsUnits {
  getGpsUnits {
    name
    alias
  }
}
    `;

/**
 * __useGetGpsUnitsQuery__
 *
 * To run a query within a React component, call `useGetGpsUnitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGpsUnitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGpsUnitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetGpsUnitsQuery(baseOptions?: Apollo.QueryHookOptions<GetGpsUnitsQuery, GetGpsUnitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGpsUnitsQuery, GetGpsUnitsQueryVariables>(GetGpsUnitsDocument, options);
      }
export function useGetGpsUnitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGpsUnitsQuery, GetGpsUnitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGpsUnitsQuery, GetGpsUnitsQueryVariables>(GetGpsUnitsDocument, options);
        }
export type GetGpsUnitsQueryHookResult = ReturnType<typeof useGetGpsUnitsQuery>;
export type GetGpsUnitsLazyQueryHookResult = ReturnType<typeof useGetGpsUnitsLazyQuery>;